/**
 * CartSettingsPresenter
 * --
 */
import React from 'react';
import { Content, Title, Row, Col, InputFormTable, Text } from 'components';
import { Button, Radio, InputNumber, Spin } from 'antd';
import lodash from 'utils/Lodash';

const CartSettingsPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { setting, origin, isLoading, onChange, onSubmit } = props;

  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    subTitle: {
      fontSize: 17,
      fontWeight: 500,
      lineHeight: '141%',
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const form = [
    {
      label: '장바구니 저장 기간',
      form: [
        {
          input: (
            <>
              <InputNumber
                size="large"
                style={{ ...styles.form.input.large }}
                placeholder="직접입력"
                value={setting.max_save_date}
                onChange={(e) => onChange('max_save_date', e)}
                min={0}
                suffix={'일 후 삭제'}
              />
            </>
          ),
        },
      ],
      message: (
        <Text size={12} color={'#D33444'}>
          0일로 설정할 경우 삭제하지 않음.
        </Text>
      ),
    },
  ];

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Spin spinning={isLoading}>
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            <Title style={{ ...styles.title }}>장바구니 설정</Title>

            {/* 기본정보 */}
            <Content
              maxWidth={'100%'}
              padding={20}
              borderRadius={4}
              style={{ marginBottom: 40 }}
            >
              <Title style={{ ...styles.subTitle }}>기본 정보</Title>
              <InputFormTable form={form} />
            </Content>
            {/* 기본정보 끝 */}

            {/* 버튼 */}
            <Content maxWidth={'100%'} backgroundColor={'none'}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Button
                  size="large"
                  type="primary"
                  style={{
                    background: 'var(--primary-color)',
                  }}
                  disabled={lodash.isEqual(origin, setting)}
                  onClick={() => onSubmit()}
                >
                  장바구니 설정
                </Button>
              </div>
            </Content>
            {/* 버튼 끝 */}
          </Col>
        </Row>
      </Content>
    </Spin>
  );
};

export default CartSettingsPresenter;
